module.exports = "\n<div class=\"comp-popups-container\" :class=\"[visible ? 'comp-popups-container-visible' : '']\">\n  <component v-for=\"key in popupsOrder\" :is=\"componentNameForKey(key)\" :payload=\"dataForKey(key)\" :key=\"key\"></component>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/shared_frontend/components/popups_container/index.pug
// module id = 643
// module chunks = 5